import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import blackListsActions from '../actions/blackList'

export const useBlackLists = () => {
  const data = useSelector((state) => {
    return get(state, 'app.blackListsManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(blackListsActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
